"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,7.39V5.67a2.86,2.86,0,0,0-2.86-2.86H2.87A2.86,2.86,0,0,0,0,5.67V7.39H24ZM4,6.24a.57.57,0,1,1,.57-.57A.57.57,0,0,1,4,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,6.3,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,8.58,6.24Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,18.24V8.53H0v9.71A2.86,2.86,0,0,0,2.87,21.1H21.15A2.86,2.86,0,0,0,24,18.24Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13,16.39V10.84a1,1,0,1,0-2.09,0v5.55a1.88,1.88,0,1,0,2.09,0Zm-1,2.19a.63.63,0,0,1-.21-1.22V12.93a.21.21,0,0,1,.42,0v4.43A.63.63,0,0,1,12,18.58Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16.2",
    cy: "10.81",
    r: "0.12",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.54,9.8A1.44,1.44,0,1,0,17,11.23,1.44,1.44,0,0,0,15.54,9.8ZM15.85,12a.9.9,0,1,1,0-1.59.12.12,0,0,1-.11.21.66.66,0,1,0,0,1.16.12.12,0,0,1,.11.21Zm.35-1a.24.24,0,1,1,.24-.24A.24.24,0,0,1,16.2,11.05Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;